<template>
  <main id="authorAdmin" v-if="config.status.authed">
    <ul class="authors">
      <li class="header">
        <span>ユーザー名</span>
        <span>名前</span>
        <span>Eメール</span>
        <span>所属</span>
        <span>ステータス</span>
        <span class="com"></span>
      </li>
    </ul>
  </main>
</template>

<script>
export default {
  name: 'authorAdmin',
  components: {
  },
  data () {
    return {
      config: {
        status: {
          authed: false,
          loading: true
        }
      },
      authors: {}
    }
  },
  created () {
    console.log(this.$props)
    this.init()
  },
  methods: {
    init: function () {
      this.auth()
      this.get()
    },
    auth: function () {
      let roles = this.$store.getters['author/get']('roles')
      let permit = this.$route.meta.permit
      if (!roles.includes(permit)) {
        this.$router.push('/')
      } else {
        this.$set(this.config.status, 'authed', true)
      }
    },
    get: function () {
      this.$set(this.config.status, 'loading', true)
      let url = this.$store.getters['config/get']('baseUrl') + 'ajax'
      let fd = new FormData()
      fd.append('ajax', 'author')
      fd.append('act', 'get')
      fd.append('type', 'list')
      this.axios.post(url, fd).then(res => {
        console.log(res)
        if (res.data.success && res.data.success === true) {
          this.$set(this, 'authors', {})
          for (let i = 0; i < res.data.data.length; i++) {
            let data = res.data.data[i]
            this.$set(this.authors, data.id, data)
          }
        }
        this.$set(this.config.status, 'loading', false)
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>
